import { useMemo, useState } from 'react';
import { formatStat, normalizeShape } from '../lib/gemLogic.js';


export default function GemListPage({ gems, onChange, t }) {
  const [draftQuery, setDraftQuery] = useState('');
  const [query, setQuery] = useState('');
  const [shape, setShape] = useState('전체');
  const [selected, setSelected] = useState(new Set());

  const normal = useMemo(() => gems.filter((g) => !['보류', '휴지통'].includes(g.status)), [gems]);
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return normal.filter((g) => {
      if (shape !== '전체' && normalizeShape(g.shape) !== shape) return false;
      if (!q) return true;
      const hay = [g.id, g.name, g.shape, g.enhancement, g.main_stat?.name, g.main_stat?.value,
        g.set_option, g.equipped_to, g.file_name, ...(g.sub_stats || []).flatMap((s) => [s?.name, s?.value])]
        .filter((x) => x != null).join(' ').toLowerCase();
      return hay.includes(q);
    });
  }, [normal, query, shape]);

  const rows = filtered;

  function toggle(id) {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }

  function moveSelectedToTrash() {
    if (!selected.size) return;
    onChange(gems.map((g) => selected.has(g.id) ? { ...g, status: '휴지통' } : g));
    setSelected(new Set());
  }

  return (
    <section className="page-section">
      <div className="section-heading">
        <div>
          <h2>📋 {t('list')}</h2>
          <p>{filtered.length.toLocaleString()} / {normal.length.toLocaleString()}</p>
        </div>
        <button className="danger" disabled={!selected.size} onClick={moveSelectedToTrash}>
          🗑️ {t('moveTrash')} ({selected.size})
        </button>
      </div>

      <form
        className="filters-row"
        onSubmit={(e) => {
          e.preventDefault();
          setQuery(draftQuery);
        }}
      >
        <input
          value={draftQuery}
          onChange={(e) => setDraftQuery(e.target.value)}
          placeholder={`🔎 ${t('search')}`}
        />
        <button type="submit">🔎 {t('search')}</button>
        <select value={shape} onChange={(e) => setShape(e.target.value)}>
          <option value="전체">{t('all')}</option>
          <option value="네모">■ 네모 / Square</option>
          <option value="세모">▲ 세모 / Triangle</option>
          <option value="마름모">◆ 마름모 / Diamond</option>
        </select>
      </form>

      <div className="table-wrap gem-list-table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th></th><th>ID</th><th>★</th><th>보석</th><th>{t('shape')}</th><th>{t('enhancement')}</th>
              <th>{t('mainStat')}</th><th>{t('subStats')}</th><th>{t('setOption')}</th><th>{t('equippedTo')}</th><th>{t('fileName')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((g) => (
              <tr key={g.id} className={g.is_uncertain ? 'uncertain-row' : ''}>
                <td><input type="checkbox" checked={selected.has(g.id)} onChange={() => toggle(g.id)} /></td>
                <td>{g.id}</td>
                <td>{g.star ?? 6}</td>
                <td>{g.name || '-'}</td>
                <td>{normalizeShape(g.shape)}</td>
                <td>+{g.enhancement ?? 0}</td>
                <td>{formatStat(g.main_stat)}</td>
                <td className="compact-cell">{(g.sub_stats || []).map(formatStat).join(', ')}</td>
                <td className="compact-cell">{g.set_option || '-'}</td>
                <td>{g.equipped_to || '-'}</td>
                <td className="mono">{g.file_name || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
